module.exports = __webpack_public_path__ + "static/img/IOS.e43581f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IOS.jpg
// module id = peyS
// module chunks = 1